export const PARTNERS_MODIFY_MANAGE = { resource: 'manage-partners', code: 'modify' };

export const CO_BRANDED_PAGE_CREATE_MANAGE = { resource: 'co-branded', code: 'manage_page_create' };
export const CO_BRANDED_CONCIERGE_MANAGE = { resource: 'co-branded', code: 'manage_concierge' };
export const CO_BRANDED_PAGE_ACCESS = { resource: 'co-branded', code: 'access' };
export const CO_BRANDED_PAGE_ACCESS_MANAGE = { resource: 'co-branded', code: 'manage_access' };


export const MANAGE_SETTINGS_MODIFY = { resource: 'manage-settings', code: 'modify' };
export const MANAGE_SETTINGS_ACCESS = { resource: 'manage-settings', code: 'access' };

export const MARKETING_MATERIALS_ACCESS = { resource: 'marketing-materials', code: 'access' };
export const MARKETING_MATERIALS_MANAGE_MODIFY = { resource: 'marketing-materials', code: 'manage_modify' };
export const MARKETING_MATERIALS_MANAGE_ACCESS = { resource: 'marketing-materials', code: 'manage_access' };

export const MANAGE_NEWS_AND_UPDATES_MODIFY = { resource: 'manage-news-and-updates', code: 'modify' };
